// taken from https://hackernoon.com/naive-infinite-scroll-in-reactive-programming-using-rxjs-observables-4a605d3146e8
import { range, interval } from 'rxjs';
import { filter, map, zip } from 'rxjs/operators';
import BezierEasing from 'bezier-easing';

// t = current time
// b = start value
// c = change in value
// d = duration

const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  const easing = BezierEasing(0.23, 1, 0.32, 1);
  return b + c * easing(t / d);
};

const logDone = () => {
  // console.log('done');
};

/**
 * animate scroll to endY over duration
 * @param endY
 * @param duration total time of animation to complete
 * @param onScrollFinish function to call at completion of animation
 * @param frameInterval number of ms between each frame
 */

export const scrollToYOverTime = (
  endY: number,
  duration: number,
  onScrollFinish: () => void = logDone,
  frameInterval: number = 16
) => {
  const _scrollToY = (value: number) =>
    window.requestAnimationFrame(() => {
      window.scrollTo(0, value);
    });
  const startY =
    document.documentElement && document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  const scrollValueGenerator = (timeFromStart: number) => easeInOutQuad(timeFromStart, startY, endY - startY, duration);

  const scrollValueEmiter = range(0, duration).pipe(
    filter(n => n % frameInterval === 0 || n === duration - 1),
    map(scrollValueGenerator),
    zip(interval(frameInterval), a => a)
  );

  scrollValueEmiter.subscribe(_scrollToY, undefined, onScrollFinish);
};

/**
 * animate scroll, but increases the duration of time depending on the distance to travel
 * @param endY
 * @param onScrollFinish function to call at completion of animation
 * @param frameInterval number of ms between each frame
 */
export const scrollToYCasually = (endY: number, onScrollFinish: () => void = logDone, frameInterval: number = 16) => {
  const startY =
    document.documentElement && document.documentElement.scrollTop
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
  const idealRate = 1.5; // pixes per ms
  const duration = Math.abs(startY - endY) / idealRate;
  return scrollToYOverTime(endY, duration, onScrollFinish, frameInterval);
};

// How to refactor highly abstract function that uses many other functions ?
